/* Dynamic checkout translation patch */
(function () {
  const labels = {
    uk: 'Cumpără acum',
    ru: 'Cumpără acum',
    ro: 'Cumpără acum',
  };

  function currentLabel() {
    const locale = (
      document.documentElement.lang ||
      (window.Shopify && window.Shopify.locale) ||
      'ro'
    ).toLowerCase();

    if (locale.startsWith('ru')) {
      return labels.ru;
    }

    if (locale.startsWith('uk')) {
      return labels.uk;
    }

    return labels.ro;
  }

  function translateDynamicCheckoutButtons() {
    const translatedLabel = currentLabel();
    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach((button) => {
      const label = button.textContent.trim();

      if (/^(buy it now|buy now)$/i.test(label)) {
        button.textContent = translatedLabel;
        button.setAttribute('aria-label', translatedLabel);
      }
    });
  }

  let queued = false;

  function scheduleTranslation() {
    if (queued) return;
    queued = true;

    window.requestAnimationFrame(() => {
      queued = false;
      translateDynamicCheckoutButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleTranslation);
  } else {
    scheduleTranslation();
  }

  window.addEventListener('load', scheduleTranslation);
  document.addEventListener('shopify:section:load', scheduleTranslation);

  const observer = new MutationObserver(scheduleTranslation);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
